function currencyFormatter (currency, sign = '') {
  let sansDec = currency.toFixed(2)
  let formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",")

  return sign + ` ${formatted}`;
}

function dateFormatter (date) {
  if (!date) {
    return
  }

  let dateAsString = date.toString().substring(0, 10)
  let dateParts = dateAsString.split("-")

  let day = dateParts[2]
  let month = dateParts[1]
  let year = dateParts[0]

  return `${day}/${month}/${year}`;
}

function dateTimeFormatter (date) {
  if (!date) {
    return
  }

  if (date === '0001-01-01T00:00:00') {
    return
  }

  let dateAsString = date.toString().substring(0, 10)
  let hours = date.toString().substring(11, 16)
  let dateParts = dateAsString.split("-")
  
  let day = dateParts[2]
  let month = dateParts[1]
  let year = dateParts[0]

  return `${day}/${month}/${year} ${hours}`;
}

let localizedTextsMapColumns = {
  columnMenuUnsort: 'No ordenar',
  columnMenuSortAsc: 'Ordenar ASC',
  columnMenuSortDesc: 'Ordenar DESC',
  columnMenuShowColumns: 'Mostrar columnas',
  columnMenuFilter: 'Filtro',
  columnMenuHideColumn: 'Ocultar',
  columnMenuManageColumns: 'Administrar columnas',
  columnsPanelHideAllButton: 'Ocultar todas',
  columnsPanelShowAllButton: 'Mostrar todas',
  filterOperatorContains: 'Contiene',
  filterOperatorEquals: 'Es igual',
  filterPanelColumns: 'Columnas',
  filterPanelInputPlaceholder: 'Filtro',
  filterPanelOperator: 'Operador',
  filterPanelInputLabel: 'Valor'
}

let formatters = {
  currencyFormatter,
  dateFormatter,
  dateTimeFormatter,
  localizedTextsMapColumns
}

export default formatters